<script lang="ts" setup>
import H2Heading from "~/components/H2Heading.vue";

// Properties
</script>

<template>
    <div class="bg-abc-gray items-center py-10 lg:flex lg:py-4 xl:py-0">
        <div class="flex-1 px-4 lg:w-1/2 lg:px-0 lg:pl-14">
            <H2Heading size="text-2xl lg:text-3xl" class="mb-4 text-center lg:text-left">Diversity & Culture</H2Heading>
            <p class="mb-6">
                At American Book Company, we believe our people are the secret to creating great classroom solutions. We
                embrace the diversity of our team and make inclusion part of our core values. We celebrate the unique
                perspectives and skills each team member brings to work every day. A diverse team makes our
                solutions–the books and digital programs used in classrooms throughout the country–more accessible and
                engaging for all.
            </p>
            <p>
                American Book Company provides equal opportunities to all employees and applicants for employment
                without regard to race, religion, color, age, sex, national origin, sexual orientation, gender identity,
                genetic disposition, neurodiversity, disability, veteran status or any other protected category under
                federal, state and local law.
            </p>
        </div>
        <div class="mt-10 flex-1 lg:mt-0 lg:w-1/2 lg:pl-16">
            <NuxtImg src="/images/about/diversity_desktop_722x762px.png" class="hidden md:block" />
            <NuxtImg src="/images/about/diversity_mobile_518x320px.png" class="mx-auto md:hidden" />
        </div>
    </div>
</template>

<style scoped></style>
